import { IconContent } from '@icons';

export const funnel: IconContent = {
    sm: '<path d="M2.5 2.361h11v2.096l-.146.147-2.91 2.909v4.289l-.303.13-3.888 1.666-.697.3V7.512l-2.91-2.91-.146-.146V2.361Zm1 1v.682l2.91 2.909.146.146v5.283l2.888-1.239V7.099l.147-.146 2.909-2.91v-.68h-9Z" />',
};
